<template>
  <div>
    <div class="head_c">
      <div class="title">可用积分： <span>100</span></div>
      <div class="flex_c">
        <div>
          <p style="font-weight: 900">100</p>
          <p>当月积分</p>
        </div>
        <div>
          <p style="font-weight: 900">100</p>
          <p>累计积分</p>
        </div>
      </div>
      <div class="time">
        <van-field v-model="text" @click="naturePicker = true" />
      </div>
      <div>
        <van-popup v-model="naturePicker" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="year-month"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="timeConfirm"
            @cancel="naturePicker = false"
          />
        </van-popup>
      </div>
    </div>
    <div>
      <div class="tab_con m_flex_box flex_vb">
        <span :class="tab === 0 ? 'active' : ''" @click="changeTab(0)"
          >全部记录</span
        >
        <span :class="tab === 1 ? 'active' : ''" @click="changeTab(1)"
          >获取积分</span
        >
        <span :class="tab === 2 ? 'active' : ''" @click="changeTab(2)"
          >使用积分</span
        >
      </div>
      <div class="flex_n">
        <div class="task_1">
          <p>签到</p>
          <p>2021-05-16 10：36：13</p>
        </div>
        <div class="task_2">+2</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "2016-1",
      tab: 0,
      naturePicker: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
    };
  },
  created() {
    var date = new Date();
    var year = date.getFullYear(); // 获取完整的年份(4位,1970)
    var month = date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)F
    this.text = year + "-" + month;
  },
  methods: {
    timeConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear(); // 获取完整的年份(4位,1970)
      var month = date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)F
      this.text = year + "-" + month;
      this.naturePicker = false;
    },
    changeTab(num) {
      this.tab = num;
    },
  },
};
</script>
<style lang="less" scoped>
.head_c {
  padding: 0.5rem 0;
  background: #007fff;
  overflow: hidden;
  .title {
    color: #fff;
    font-size: 0.27rem;
    text-align: center;
    padding: 0.3rem 0;
    span {
      font-size: 0.6rem;
      font-weight: 900;
    }
  }
  .flex_c {
    display: flex;
    & > div {
      flex: 1;
      p {
        color: #fff;
        font-size: 0.27rem;
        padding: 5px 0;
        text-align: center;
      }
    }
  }
  .time {
    width: 1.5rem;
    float: right;
    overflow: hidden;
    padding-top: 0.1rem;
    .van-cell {
      padding: 0;
    }
  }
}

.tab_con {
  height: 1rem;
  background-color: #fff;
  display: flex;
  z-index: 9;
  span {
    flex: 1;
    font-weight: 800;
    font-size: 0.3rem;
    margin: 0.3rem;
    position: relative;
    text-align: center;
  }
  .active {
    color: #3072f5;
    font-size: 0.3rem;
    &:after {
      content: "";
      bottom: -0.2rem;
      position: absolute;
      display: block;
      left: 50%;
      // margin-left: -0.2rem;
      transform: translateX(-50%);
      background-color: #3072f5;
      width: 0.7rem;
      height: 0.04rem;
    }
  }
}
.flex_n {
  display: flex;
  padding: 0.25rem 0.35rem;
  font-size: 0.27rem;
  border-bottom: 2px solid #cfcfcf;
  .task_1 {
    flex: 0 1 80%;
  }
  .task_2 {
    text-align: center;
    flex: 1;
  }
}
</style>